module.exports = __webpack_public_path__ + "static/media/centro_medio_1(1).01ca72cb.jpg";